/* eslint-disable react/display-name */
import React, { useMemo, useState } from 'react';
import {
  IComponentFilterType,
  IComponentProps,
  ILogConfigType
} from "@/pages/dashboard/components/PageContainer/type";
import { FORM_MAP } from '@/pages/dashboard/utils/_config/constant';
import componentMap from '@/pages/dashboard/_config/compConfig';
import { FilterContext } from '../context';
import Render from '../Render';
import DefualtComponetCo from '../../DefualtComponetCo';
import { useProps } from "@/pages/dashboard/components/PageContainer/Render/hooks";
import useExtraSelector from '@/pages/dashboard/hooks/useExtraSelector';

export interface IFilterWrapProps extends IComponentProps {
  config: IComponentFilterType;
  logConfig: ILogConfigType;
  filterIndex: number;
  pagePath?: string;
  timeZone: string;
}

export default (props: IFilterWrapProps) => {
  const { config: filter, filterIndex, logConfig, pagePath, timeZone } = props;

  const { pageId, pagePath: logPagePath } = logConfig || {};
  const { data, changeData } = useProps(props);

  const [filterVal, setFilterVal] = useState<any>({
    [FORM_MAP.RANGE_TIME_DIFF]: false,
    timeType: 'Day',
    timeZone: timeZone || 0,
  });

  const [filterLoading, setFilterLoading] = useState(true);
  const {
    name,
    isOpenSticky,
    isHaveFilterSave,
    filterPath,
    componentList,
    extraFilterList,
    selectorApi,
    extraSelectorParams,
    className: filterClassName,
  } = filter || {};
  const FilterComponent: any = componentMap?.[name];

  // 获取额外的筛选器数据
  const { extraSelector } = useExtraSelector(extraFilterList);

  const handleConfirm = (value: any) => {
    setFilterVal({
      ...filterVal,
      ...value,
    });
  };

  const handleInit = (value: any) => {
    setFilterLoading(false);
    setFilterVal({
      ...filterVal,
      ...value,
    });
  };

  if (!FilterComponent) {
    return <DefualtComponetCo />;
  }

  const filterPathVal = useMemo(() => {
    const result = filterPath ? filterPath : (pagePath || logPagePath);
    return result.startsWith('/') ? result.slice(1) : result;
  }, [filterPath, pagePath, logPagePath]);

  return (
    <>
      <FilterComponent
        key={`${pagePath}-${logPagePath}-${filterIndex}`}
        path={filterPathVal}
        config={filter}
        className={filterClassName}
        openSticky={isOpenSticky}
        isHaveFilterSave={isHaveFilterSave}
        selectorApi={selectorApi}
        extraSelectorParams={extraSelectorParams}
        formValue={filterVal}
        filterConfirm={handleConfirm}
        filterReset={handleConfirm}
        buttonLogConfig={{
          pageId: pageId,
          confirmButtonId: `${pageId}9${filterIndex}1`,
          resetButtonId: `${pageId}9${filterIndex}2`,
        }}
        timeZone={parseInt(timeZone || '') || 0}
        filterLoading={filterLoading}
        setFilterLoading={setFilterLoading}
        filterInit={handleInit}
        data={data}
        changeData={changeData}
      >
        <FilterContext.Provider value={
          {
            filterVal,
            filterLoading,
            setFilterVal,
            extraSelector,
          }}>

          {
            componentList?.map((item, index) => {
              return <>
                <Render logConfig={logConfig} config={{ ...(item || {}), filterPath: `/${filterPathVal}` }} data={data} changeData={changeData} key={`${item.name}-${index}`} />
              </>;
            })
          }
        </FilterContext.Provider>
      </FilterComponent>
    </>
  );
};


